module.exports = __webpack_public_path__ + "img/dieu.8e6b9f53.jpg";